export default __webpack_public_path__ + "static/media/degen_tavern.7287ad64.png";